export { default as YandexInImageAd } from './YandexInImageAd';
